import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Sedes, PuntoAtencion, LineaProducto, Empresa, Procedimiento, DatosBaseResolucionEntity } from 'src/app/services/servicio-resolucion1552.service';
import { FiltrosResolucionEntity, FiltrosResolucionBodyEntity } from 'src/app/services/servicio-resolucion1552.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ServicioResolucion1552Service } from 'src/app/services/servicio-resolucion1552.service';
import { SelectItem } from 'primeng/api';
import { EntidadEmpresarial, FiltrosResolucionExcelEntity } from '../../../services/servicio-resolucion1552.service';
import { saveAs } from 'file-saver';
import { FileService } from '../../../services/utils/file.service';
import { ExcelService } from '../../../services/utils/excel.service';
import { FechaService } from '../../../services/utils/fecha.service';

@Component({
  selector: 'app-header-resolucion1552',
  templateUrl: './header-resolucion1552.component.html',
  styleUrls: ['./header-resolucion1552.component.css']
})

export class HeaderResolucion1552Component implements OnInit {

  canDownload: boolean; // Indicador que existe data
  loading: boolean; // Indicador de carga en header
  downloading: boolean; // Indicado de descarga en header
  fechaInicial: string; // Valor fecha inicial del formulario
  fechaFinal: string; // Valor fecha final del formulario
  sede: string;
  puntoAtencion: string;
  lineaProducto: string;
  procedimiento: string;
  empresa: string;
  sedeEntidadEmpresarial: Sedes;
  mensajeError: string; // Mensaje de error
  nombreUsuario: string;

  sedes: Sedes[]; // Lista sedes
  puntosAtencion: PuntoAtencion[];
  lineasProducto: LineaProducto[];
  procedimientos: Procedimiento[];
  empresas: Empresa[];

  sedesItem: SelectItem[] = [];
  sedesSelected: SelectItem[] = [];

  puntosItem: SelectItem[] = [];
  puntosSelected: SelectItem[] = [];

  lineasItem: SelectItem[] = [];
  lineasSelected: SelectItem[] = [];
  mensaje: String = 'Cargando...';

  procedimientosItem: SelectItem[] = [];
  procedimientosSelected: SelectItem[];

  empresasItem: SelectItem[] = [];
  empresasSelected: SelectItem[] = [];


  @Input() public codigoBaseDatos: string;
  @Input() public uncoSede: string;
  @Input() public uncoLogin: number;
  @Input() public uncoPuntoAtencion: string;
  @Input() public uncoLineaProducto: string;
  @Input() public uncoEntidad: number;
  @Input() public objectDataResolucionEntity: FiltrosResolucionBodyEntity[];
  @Input() public objetoDatosEntity: DatosBaseResolucionEntity;
  @Input() public objetoFiltroEntity: FiltrosResolucionEntity;
  @Input() public objetoDataFiltroEntity: FiltrosResolucionBodyEntity[];
  @Output() filtrosSeleccionados: EventEmitter<FiltrosResolucionEntity>;
  @Output() entidadEmpresarial: EventEmitter<EntidadEmpresarial>;
  @Output() cargandoFiltros: EventEmitter<any>;

  // entidadEmpresarial: EntidadEmpresarial = {

  //   unco: 0,
  //   nombreEntidad: '',
  //   nit: '',
  //   direccion: 0,
  //   telefono: '',
  // };

  constructor(private servicioResolucion1552: ServicioResolucion1552Service,
    private servicioArchivo: FileService,
    private servicioFecha: FechaService,
    private servicioExcel: ExcelService) {
    this.loading = true;
    this.filtrosSeleccionados = new EventEmitter();
    this.entidadEmpresarial = new EventEmitter();
    this.cargandoFiltros = new EventEmitter();
  }

  ngOnInit() {
    this.init();
  }
  // tslint:disable-next-line:use-life-cycle-interface
  ngOnChanges() {

  }

  filtrarPuntosAtencion() {
    this.getPuntosAtencion();
  }

  init() {
    this.sede = '-1';
    this.getSedes();
    this.getEntidadEmpresarial();

    if (this.objetoFiltroEntity && this.objetoFiltroEntity.fechaInicial > 0) {
      this.fechaInicial = this.servicioFecha.getInputValue(this.objetoFiltroEntity.fechaInicial);
    }

    if (this.objetoFiltroEntity && this.objetoFiltroEntity.fechaFinal > 0) {
      this.fechaFinal = this.servicioFecha.getInputValue(this.objetoFiltroEntity.fechaFinal);
    }

    if (this.objetoFiltroEntity && this.objetoFiltroEntity.sede) {
      this.sede = this.objetoFiltroEntity.sede;
    }

    if (!this.sedes || this.sedes.length === 0) {
      this.getSedes();
      if (this.objetoFiltroEntity && this.objetoFiltroEntity.sede) {
        this.sede = String(this.objetoFiltroEntity.sede);
      } else {
        this.sede = '-1';
      }
    }

    if (this.fechaInicial && this.fechaFinal && this.sede !== '0') {
      this.onGenerar();
    }
  }

  async getEntidadEmpresarial() {
    try {
      // this.sedeEntidadEmpresarial.entidadEmpresarial = {
      //   unco: 1,
      //   telefono: '',
      //   direccion: '',
      //   nit: '',
      //   descripcion: '',
      //   uncoEntidad: 1
      // };
      const response = await this.servicioResolucion1552.getEntidadEmpresarial(this.objetoDatosEntity, this.uncoEntidad);
      if (response != null) {
        response.subscribe((data: any) => {

          const entidad: EntidadEmpresarial = {
            unco: data.unco,
            nombreEntidad: data.dscrpcn_entdd_emprsrl,
            nit: data.idntfccn_trbtra,
            direccion: data.drccn,
            telefono: data.tlfno_pbx,
          };
          this.entidadEmpresarial.emit(entidad);
        }, (err: HttpErrorResponse) => {
          console.log('Error sede', err);
          if (err.status === 500) {
            this.loading = false;
          } else {
            console.log('error en entidades empresariales' + err);
          }
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getSedes() {
    try {
      const response = await this.servicioResolucion1552.getSedes(this.objetoDatosEntity);
      if (response != null) {
        response.subscribe((data: Sedes[]) => {
          this.sedes = data;
          this.loading = false;
          this.sedesItem = [];
          this.mensaje = 'Cargando...';
          data.forEach((sedeTmp: Sedes) => {
            this.sedesItem.push({ label: sedeTmp.descripcion, value: sedeTmp.unco });
          });
        }, (err: HttpErrorResponse) => {
          console.log('Error sede', err);
          if (err.status === 500) {
            this.sedes = [];
            this.loading = false;
          } else {
            console.log(err);
          }
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getPuntosAtencion() {
    try {
      const response = await this.servicioResolucion1552
        .getPuntosAtencion(this.objetoDatosEntity.codigoBaseDatos,
          this.uncoLogin, this.uncoSede);
      if (response != null) {
        response.subscribe((data: PuntoAtencion[]) => {
          this.loading = false;
          this.puntosItem = [];
          this.mensaje = 'cargando...';
          for (const puntosTemporal of data) {
            this.puntosItem.push({ label: puntosTemporal.descripcion, value: puntosTemporal.unco });
          }

        }, (err: HttpErrorResponse) => {
          console.log('Error puntos', err);
          if (err.status === 500) {
            this.sedes = [];
            this.loading = false;
          } else {
            console.log(err);
          }
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getLineaProducto() {
    // console.log('uncosPuntosSeleccionados: ' + JSON.stringify(this.puntosSelected));
    try {
      // this.cargandoFiltros.emit(true);
      const uncosPuntosAtencion = this.puntosSelected.toString();
      const response = await this.servicioResolucion1552
        .getLineaProducto(this.objetoDatosEntity.codigoBaseDatos,
          this.uncoSede, uncosPuntosAtencion);
      if (response != null) {
        response.subscribe((data: LineaProducto[]) => {
          this.lineasProducto = data;
          this.loading = false;
          this.lineasItem = [];
          this.mensaje = 'cargando...';
          for (const lineasTemporal of data) {
            this.lineasItem.push({ label: lineasTemporal.descripcionCorta, value: lineasTemporal.unco });
          }
        }, (err: HttpErrorResponse) => {
          console.log('Error lineas', err);
          if (err.status === 500) {
            this.sedes = [];
            this.loading = false;
          } else {
            console.log(err);
          }
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getProcedimiento() {
    try {
      const uncosLineasProducto = this.lineasSelected.toString();
      const response = await this.servicioResolucion1552
        .getProcedimiento(this.objetoDatosEntity.codigoBaseDatos,
          uncosLineasProducto);
      if (response != null) {
        response.subscribe((data: Procedimiento[]) => {
          this.procedimientos = data;
          this.loading = false;
          this.procedimientosItem = [];
          this.mensaje = 'cargando...';
          for (const procedimientosTemporal of data) {
            this.procedimientosItem.push({ label: procedimientosTemporal.descripcionCorta, value: procedimientosTemporal.unco });
          }

        }, (err: HttpErrorResponse) => {
          console.log('Error procedimientos', err);
          if (err.status === 500) {
            this.sedes = [];
            this.loading = false;
          } else {
            console.log(err);
          }
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getEmpresa() {
    try {
      const response = await this.servicioResolucion1552.getEmpresa(this.objetoDatosEntity.codigoBaseDatos);
      if (response != null) {
        response.subscribe((data: Empresa[]) => {
          this.empresas = data;
          this.loading = false;
          this.empresasItem = [];
          this.mensaje = 'cargando...';
          data.forEach((empresaTemporal: Empresa) => {
            this.empresasItem.push({ label: empresaTemporal.descripcionCorta, value: empresaTemporal.unco });
          });

        }, (err: HttpErrorResponse) => {
          console.log('Error empresa', err);
          if (err.status === 500) {
            this.empresas = [];
            this.loading = false;
          } else {
            console.log(err);
          }
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  onGenerar() {
    const inicio = this.servicioFecha.getFecha(this.fechaInicial);
    const fin = this.servicioFecha.getFecha(this.fechaFinal);

    const obj: FiltrosResolucionEntity = {
      codigoBaseDatos: this.codigoBaseDatos,
      fechaInicial: 0,
      fechaFinal: 0,
      sede: '-1',
      puntoAtencion: '-1',
      lineaProducto: '-1',
      procedimiento: '-1',
      empresa: '-1',
    };

    if (inicio === null || inicio.getTime() === 0) {
      this.filtrosSeleccionados.emit(obj);
      this.mostrarMensaje('Debe seleccionar la <strong>Fecha Inicial</strong>.');
    } else if (fin === null || fin.getTime() === 0) {
      this.filtrosSeleccionados.emit(obj);
      this.mostrarMensaje('Debe seleccionar la <strong>Fecha Final</strong>.');
    } else if (this.sedesSelected.length === 0) {
      this.filtrosSeleccionados.emit(obj);
      this.mostrarMensaje('Debe seleccionar el campo <strong>Sede</strong>.');
    } else if (this.puntosSelected.length === 0) {
      this.filtrosSeleccionados.emit(obj);
      this.mostrarMensaje('Debe seleccionar el campo <strong>Puntos de Atención</strong>.');
    } else if (this.lineasSelected.length === 0) {
      this.filtrosSeleccionados.emit(obj);
      this.mostrarMensaje('Debe seleccionar el campo <strong>Líneas de Producto</strong>.');
    } else if (this.procedimientosSelected.length === 0) {
      this.filtrosSeleccionados.emit(obj);
      this.mostrarMensaje('Debe seleccionar el campo <strong>Procedimientos</strong>.');
    } else if (this.empresasSelected.length === 0) {
      this.filtrosSeleccionados.emit(obj);
      this.mostrarMensaje('Debe seleccionar el campo <strong>Empresas</strong>.');
    } else if (this.servicioFecha.compare(inicio, fin) === 1) {
      this.filtrosSeleccionados.emit(obj);
      this.mostrarMensaje('La <strong>Fecha Inicial</strong> debe ser menor o igual a la <strong>Fecha Final</strong>');
    } else {
      obj.fechaInicial = inicio.getTime();
      obj.fechaFinal = fin.getTime();
      obj.sede = String(this.sedesSelected);
      obj.puntoAtencion = String(this.puntosSelected);
      obj.lineaProducto = String(this.lineasSelected);
      obj.procedimiento = String(this.procedimientosSelected);
      obj.empresa = String(this.empresasSelected);
      this.objetoFiltroEntity = obj;
      this.canDownload = obj.fechaInicial > 0;
      this.filtrosSeleccionados.emit(obj);
    }
  }

  onDescargarExcel() {
    this.downloading = true;
    const initialData: FiltrosResolucionBodyEntity[] = this.objectDataResolucionEntity;
    const finalData: FiltrosResolucionExcelEntity[] = [];

    if (initialData && initialData.length > 0) {
      initialData.forEach((d: FiltrosResolucionBodyEntity) => {
        const f: FiltrosResolucionExcelEntity = {
          codigoEps: d.codigoEps,
          primerNombreAfiliado: d.primerNombreAfiliado,
          segundoNombreAfiliado: d.segundoNombreAfiliado,
          primerApellidoAfiliado: d.primerApellidoAfiliado,
          segundoApellidoAfiliado: d.segundoApellidoAfiliado,
          tipoDocumento: d.tipoDocumento,
          numeroIdentificacion: d.numeroIdentificacion,
          departamento: d.departamento,
          municipio: d.municipio,
          direccion: d.municipio,
          telefono: d.telefono,
          fechaAsignacionCita: d.fechaAsignacionCita,
          fechaDeseadaUsuario: d.fechaAsignacionCita,
          fechaCita: d.fechaCita,
          codigoHabilitado: d.codigoHabilitado,
          servicioHabilitado: d.servicioHabilitado,
          servicio: d.servicio,
          codigoRepss: d.codigoRepss,
          numeroTotalCitas: d.numeroTotalCitas,
          fechaCitaFechaAsignada: d.fechaCitaFechaAsignada,
          fechaAsignadaFechaDeseada: d.fechaAsignadaFechaDeseada,
          estadoCita: d.estadoCita,
          empresa: d.empresa,

          // fechaEntrega: new Date(d.fechaEntrega),
          // fechaSolicitud: new Date(d.fechaSolicitud),
          // usuarioCreacion: d.usuarioCreacion,
        };
        finalData.push(f);
      });
      this.servicioExcel.exportAsExcelFile(finalData, 'reporteResolucion', 'Reporte Resolucion');
      this.downloading = false;
    } else {
      this.mostrarMensaje('No existen datos para descargar, verifique los filtros. De lo contrario contactese con su administrador');
      this.downloading = false;
    }
  }
  // Auxiliares

  mostrarMensaje(mensaje: string) {
    this.mensajeError = mensaje;
    setTimeout(() => {
      this.mensajeError = null;
    }, 5000);
  }

}



